// extracted by mini-css-extract-plugin
export default {"link":"FDNdms","root":"lp9qf3","label":"lll5Zq"};